
import B3Request from '../../request/b3Fetch';

const getCustomerQuery = () => `query customer {
  customer {
    entityId
    phone
    firstName
    lastName
    email
    customerGroupId
  }
}`;

const getWishlistQuery = () => `query wishlist($first: Int, $after: String, $before: String) {
  customer {
    wishlists(first: $first, after: $after, before: $before) {  # Now supports before & after conditionally
      edges {
        node {
          entityId
          token
          name
          items {
            collectionInfo
            {
              totalItems
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}`;

const getWishlistDetailQuery = () => `query wishlistItem($wishlistId: Int!, $imageWidth: Int!, $imageHeight: Int!, $first: Int, $after: String, $before: String) {
  customer {
    wishlists(filters: {entityIds: [$wishlistId]})
    {
      edges
        {
          node
            {
          name
          items(first: $first, after: $after, before: $before)
            {
              edges {
                node{
                  entityId  
                  product
                  {
                    sku
                    images(first: 1) {
                      edges {
                        node {
                          url(width: $imageWidth, height: $imageHeight)
                        }
                      }
                    }
                    brand {
                      name
                    }
                    name
                    path
                    prices {
                      price {
                        value
                        currencyCode
                      }
                      salePrice {
                        value
                        currencyCode
                      }
                    }
                    customFields {
                      edges {
                        node {
                          name
                          value
                        }
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
              }
              collectionInfo {
                totalItems
              }
            }
          }
        }
      }
    }
}`;

const removeWishlistItemMutation = () => `mutation deleteWishlistItems($wishlistEntityId: Int!, $wishlistItemEntityIds: [Int!]!) {
  wishlist {
    deleteWishlistItems(
      input: {
        entityId: $wishlistEntityId
        itemEntityIds: $wishlistItemEntityIds
      }
    ) {
      result {
        entityId
        name
        token
      }
    }
  }
}`;

const deleteWishlistMutation = () => `mutation deleteWishlist($wishlistEntityId: [Int!]!) {
  wishlist {
    deleteWishlists(
      input: {
        entityIds: $wishlistEntityId
      }
    ) {
      result
    }
  }
}`;

const updateWishlistMutation = () => `mutation updateWishlist($entityId: Int!, $name: String) {
  wishlist {
    updateWishlist(input:{
      entityId: $entityId,
      data:{
        name: $name
      }
    }){
      result{
        entityId
        name
      }
    }
  }
}`;

const createNewWishlistMutation = () => `mutation createWishlist($name: String!, $isPublic:Boolean!) {
  wishlist {
    createWishlist(input: {
      name:$name
      isPublic:$isPublic
    }) {
      result {
        entityId
        name
        token
      }
    }
  }
}`;

export const getWishlistDetail = (wishlistId: number, count: number = 2, cursor?: string, direction: 'next' | 'prev' = 'next') => {
  const variables: any = {};
  variables.wishlistId = wishlistId;
  variables.imageHeight = 200;
  variables.imageWidth = 200;
  if (direction === 'next') {
    variables.first = count;  // Use first for next page
    if (cursor) variables.after = cursor;
  } else {
    variables.last = count;   // Use last for previous page
    if (cursor) variables.before = cursor;
  }
  return B3Request.graphqlBCProxy({
    query: getWishlistDetailQuery(),
    variables
  })
}

export const removeWishlistItem = (wishlistId: number, wishlistItemIds: number[]) => {
  const variables: any = {};
  variables.wishlistEntityId = wishlistId;
  variables.wishlistItemEntityIds = wishlistItemIds;
  return B3Request.graphqlBCProxy({
    query: removeWishlistItemMutation(),
    variables
  })
}

export const deleteWishlist = (wishlistIds: number[]) => {
  const variables: any = {};
  variables.wishlistEntityId = wishlistIds;
  return B3Request.graphqlBCProxy({
    query: deleteWishlistMutation(),
    variables
  })
}

export const updateWishlist = (wishlistId: number, wishlistNewName: String) => {
  const variables: any = {};
  variables.entityId = wishlistId;
  variables.name = wishlistNewName;
  return B3Request.graphqlBCProxy({
    query: updateWishlistMutation(),
    variables
  })
}

export const createNewWishlist = (wishlistName: String) => {
  const variables: any = {};
  variables.name = wishlistName;
  variables.isPublic = false;
  return B3Request.graphqlBCProxy({
    query: createNewWishlistMutation(),
    variables
  })
}

export const getCustomerInfo = () =>
  B3Request.graphqlBCProxy({
    query: getCustomerQuery(),
  });

  export const getWishlistInfo = (count: number = 2, cursor?: string, direction: 'next' | 'prev' = 'next') => {
    const variables: any = {};
  
    if (direction === 'next') {
      variables.first = count;  // Use first for next page
      if (cursor) variables.after = cursor;
    } else {
      variables.last = count;   // Use last for previous page
      if (cursor) variables.before = cursor;
    }
  
    return B3Request.graphqlBCProxy({
      query: getWishlistQuery(),
      variables,
    });
  };

export const customerExists = () =>
  B3Request.graphqlBCProxy({
    query: getCustomerQuery(),
  });
